<template>
  <div class="flex items-center justify-center gap-4">
    <AppButton
      v-tooltip.top="$t('acceptNewContent')"
      icon="pi pi-check"
      data-testid="accept-regenerated-content"
      @click="emit('accept')"
    />
    <AppButton
      v-tooltip.top="$t('rejectNewContent')"
      variant="secondary"
      icon="pi pi-times"
      data-testid="reject-regenerated-content"
      @click="emit('reject')"
    />
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  accept: [];
  reject: [];
}>();
</script>
